import { ImageAnnotation } from './image-annotation';

export interface MsImageLink {
    '@url': string;
    'pkid': number;
    'image': string;
    'fkidimg_files': number;
    'fkidgridstruct_sections'?: number;
    'fkidgridstruct_parts'?: number;
    'fkidgridstruct_treatises'?: number;
    'fkidgridstruct_chapters'?: number;
    'fkidms_structure'?: number;
    'fkidmanuscripts': number;
    'fkidimg_annotations'?: number;
    '__useRights': number;
    '__annotation'?: ImageAnnotation;
    'version': string;
}

export type MsImageLinkList = Array<MsImageLink>;

export class MsImageLinkSelection {
    private _label: string;
    private _images: Array<string>; // array of selected image names
    private _annotation: number; // image annotation identifier (for highlighting purposes)

    constructor(label: string = '', images: Array<string> = [], annotation: number = 0) {
        this._label = label;
        this._images = images;
        this._annotation = annotation;
    }

    reset(): void {
        this._label = '';
        this._images = [];
        this._annotation = 0;
    }

    set label(value: string) {
        this._label = value;
    }
    get label(): string {
        return this._label;
    }

    set images(value: Array<string>) {
        this._images = value;
    }
    get images(): Array<string> {
        return this._images;
    }

    set annotation(value: number) {
        this._annotation = value;
    }
    get annotation(): number {
        return this._annotation;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/ms-image-link.ts